import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../Core/Store";
import { defaultDateStrings } from "../Common/Constants";
import { startAppListening } from "../Core/listenerMiddleware";
import { isEqual, update } from "lodash";
import { push } from "react-router-redux";

export interface IServiceReportParamSliceState {
  start: string;
  end: string;
  searchAll: string;
}
const getInitialFilters = () => {
  return {
    start: defaultDateStrings.start,
    end: defaultDateStrings.jiraEnd,
    searchAll: null,
  };
};
const initialState: any = getInitialFilters();

export const updateServiceReportParams2 = createAsyncThunk(
  "params/updateServiceReportParams",
  async (serviceReportParams: IServiceReportParamSliceState, thunkAPI: any) => {
    const path = thunkAPI.getState().router.location.pathname;

    if (!isEqual(thunkAPI.getState().params, serviceReportParams)) {
      thunkAPI.dispatch(push(path, serviceReportParams));
    }
    return serviceReportParams;
  }
);

const serviceReportParamSlice = createSlice({
  name: "serviceReportParams",
  initialState,
  reducers: {
    updateServiceReportParams: (state, action: PayloadAction<any>) => {
      if (action.payload === null) {
        return initialState;
      }
      return action.payload;
    },
  },
  //,
  //extraReducers(builder) {
  //    builder.addCase(updateServiceReportParams.fulfilled, (state, action) => {
  //        return action.payload;
  //    });
  //},
});

export const { updateServiceReportParams } = serviceReportParamSlice.actions;

export const getServiceReportParamsSelector = (state: RootState) =>
  state.serviceReportParams;

export default serviceReportParamSlice.reducer;

//startAppListening({
//  predicate: (action, currentState: any, previousState: any) => {
//    return currentState.params !== previousState.params;
//  },
//  effect: (action, listenerApi) => {
//    listenerApi.dispatch<any>(updateSelectedDate({ selectedDate: null }));

//    //
//    // if(listenerApi.getState().router.location.pathname === "/alarms"){
//    //   listenerApi.dispatch<any>(fetchAlarmDatas(action.payload))
//    //   listenerApi.dispatch<any>(fetchAlarmDatasWithScope(action.payload))
//    //   listenerApi.dispatch<any>(fetchMachineTimes(action.payload))
//    // }
//    // if(listenerApi.getState().router.location.pathname === "/runningperiodcount"){
//    //   listenerApi.dispatch<any>(fetchVeryShortCount(action.payload))
//    // }
//    // if(listenerApi.getState().router.location.pathname === "/machinetimes"){
//    //   listenerApi.dispatch<any>(fetchMachineTimes(action.payload))
//    //   listenerApi.dispatch<any>(fetchAlarmDatasWithScope(action.payload))
//    // }
//  },
//});
